import { render } from "./category-levels-assessment.vue?vue&type=template&id=0917e252&ts=true"
import script from "./category-levels-assessment.vue?vue&type=script&lang=ts"
export * from "./category-levels-assessment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__